export default __webpack_public_path__ + "static/media/github_logo.9fb18537.svg";